export const carrierFormat = {
  'TMO': 'T-Mobile',
  'VZW': 'Verizon',
  'ATTED': 'AT&T'
};

export const activatedPingableStyle = { color: 'green', fontWeight: 'bold' };

export const deactivatedPingableStyle = { color: 'red', fontWeight: 'bold' };

export const SIM_STATUS = {
  'Activated': 'ACTIVATED',
  'Not Activated': 'DEACTIVATED',
  'Not Found': 'NOT_FOUND',
  'Invalid': 'INVALID',
};
